module.exports = __webpack_public_path__ + "static/media/black-circular-checkbox.8707b3a7.svg";